import React from 'react';
import { AnimateLoadedContent } from '../../../../../v2BaseComponents/Loader';
import useOrganization, {
    useIsOrganizationAdmin,
    useOrganizationSessionTimeout,
} from '../../../../../../hooks/api/useOrganization';
import SecuritySettingsEditContent from './SecuritySettingsEditContent';
import SecuritySettingsDetailsContent from './SecuritySettingsDetailsContent';
import { useSession } from '../../../../../SessionProvider';

export type SecuritySettingsTabOwnProps = {};

export type SecuritySettingsTabProps = SecuritySettingsTabOwnProps;

const SecuritySettingsTab: React.FC<SecuritySettingsTabProps> = () => {
    const { setSessionTimeoutMinutes } = useSession();
    const { isLoadingMyOrganization, isUpdatingOrganization } = useOrganization({});

    const [isEditing, setIsEditing] = React.useState(false);
    const isOrganizationAdmin = useIsOrganizationAdmin();
    const orgSessionTimeoutMinute = useOrganizationSessionTimeout();
    return (
        <AnimateLoadedContent isLoading={isLoadingMyOrganization && isUpdatingOrganization}>
            {() =>
                isEditing && isOrganizationAdmin ? (
                    <SecuritySettingsEditContent
                        orgSessionTimeout={orgSessionTimeoutMinute}
                        onCancel={() => setIsEditing(false)}
                        OnUpdate={(updatedSessionTimeoutMin) => {
                            setSessionTimeoutMinutes(updatedSessionTimeoutMin);
                            setIsEditing(false);
                        }}
                    />
                ) : (
                    <SecuritySettingsDetailsContent
                        orgSessionTimeout={orgSessionTimeoutMinute}
                        isOrgAdmin={isOrganizationAdmin}
                        onEdit={() => {
                            setIsEditing(true);
                        }}
                    />
                )
            }
        </AnimateLoadedContent>
    );
};

export default React.memo(SecuritySettingsTab);
